import {
  Box,
  Flex,
  IconButton,
  Menu,
  MenuButton,
  useBreakpointValue,
  useColorMode,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useContext, useEffect, useState } from "react";
import { FaDatabase } from "react-icons/fa";
import { GrClose, GrPhone, GrVmMaintenance } from "react-icons/gr";
import {
  MdLiveHelp,
  MdOutlineDarkMode,
  MdOutlineDevices,
} from "react-icons/md";
import { SiChatbot } from "react-icons/si";
import { fetchController } from "../../utils/FetchController/fetchController";
import useTitle from "../../utils/Hook/useTitle";
import { getHostDomain } from "../../utils/utils";
import AuthContext from "../Auth/AuthContext";
import { AgencyContext } from "../Settings/AgencyProvider/AgencyProvider";
import CallDropDownModal from "./CallDropDownModal";
import { debounce } from "lodash";
import NewSideBar from "./NewSideBar";
import { SunIcon } from "@chakra-ui/icons";
const smVariant = { navigation: "drawer", navigationButton: true };
const mdVariant = { navigation: "sidebar", navigationButton: false };

const Layout = ({ children }) => {
  const { colorMode, toggleColorMode } = useColorMode();
  const [options, setOptions] = useState([]);
  const [text, setText] = useState("");
  const agency = useContext(AgencyContext);
  const { cardBg: bg, myDetails, titleAgencyName } = agency;
  useTitle(titleAgencyName);
  const baseUrl = getHostDomain();
  const { authUser } = useContext(AuthContext);
  const variants = useBreakpointValue({ base: smVariant, md: mdVariant });
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [notificationsCount, setNotificationsCount] = useState();
  const [unreadNotification, setUnreadNotification] = useState([]);
  const [readedNotification, setReadedNotification] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tag, setTag] = useState("");

  useEffect(() => {
    const debouncedFetch = debounce(async (query) => {
      if (query.trim().length < 3) {
        setOptions([]);
        return;
      }

      const urlHit = `${baseUrl}/api/v1/link_tag_entity/search/entities?tag_term=${query}&page=1&size=50`;

      try {
        setLoading(true);
        const response = await fetchController(urlHit, "GET");
        setOptions(response.data.items[0]?.entities || []);
        setTag(response.data.items[0]?.tag);
      } catch (error) {
        console.error("Error fetching data:", error);
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 500);

    debouncedFetch(text);

    return () => debouncedFetch.cancel();
  }, [text]);

  const loadNotification = async () => {
    try {
      const Notificationresponse = await fetchController(
        baseUrl + `/api/v1/notification/latest_notifications`,
        "GET"
      );
      const SetIconToeachNotificationType =
        Notificationresponse?.data?.items.map((val, index) => {
          return {
            created_at: val.created_at,
            created_by_id: val.created_by_id,
            id: val.id,
            link: val.link,
            message: val.message,
            notification_type: val.notification_type,
            unread: val.unread,
            icon:
              val.notification_type === "conversation" ? (
                <MdOutlineDevices />
              ) : val.notification_type === "captured_intent" ? (
                <GrVmMaintenance />
              ) : val.notification_type === "datasource" ? (
                <FaDatabase />
              ) : val.notification_type === "assistant" ? (
                <SiChatbot />
              ) : (
                ""
              ),
          };
        });
      setNotifications(SetIconToeachNotificationType);
    } catch (error) {}
  };

  const filterInBsisofReadUnread = (data = []) => {
    const readedNotification = data.filter(
      (val, index) => val.unread === false
    );
    const unReadedNotification = data.filter((val, index) => val.unread);

    setNotificationsCount(unReadedNotification?.length);
    setUnreadNotification(unReadedNotification);
    setReadedNotification(readedNotification);
  };

  useEffect(() => {
    const fetchData = async () => {
      const accessToken = localStorage.getItem("token");
      if (accessToken) {
        loadNotification();
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    filterInBsisofReadUnread(notifications);
  }, [notifications]);

  const { isOpen: campaignModal, onToggle: onToggleCampaignModal } =
    useDisclosure();

  const userRoles = authUser?.roles || [];
  const isAgent = userRoles.includes("agent") && userRoles?.length === 1;

  return (
    <Flex h={"100vh"}>
      <Box h={"100%"} bg={bg} w={"260px"} boxShadow="md">
        <NewSideBar />
      </Box>

      <Flex
        h={"100%"}
        minW={"450px"}
        flex={1}
        direction={"column"}
        alignItems={"baseline"}
        position={"relative"}
      >
        <Flex
          w={"100%"}
          justifyContent={"flex-end"}
          alignItems="center"
          position={"absolute"}
        >
          <Menu isOpen={isOpen} onClose={() => setIsOpen(false)}>
            <Flex
              boxShadow="sm"
              alignItems="center"
              justify="center"
              p={2}
              gap={1}
              mt={1}
              borderRadius="8px"
              mr={4}
              mb={2}
            >
              {!isAgent ? (
                <>
                  <Box cursor={"pointer"} onClick={onToggleCampaignModal}>
                    <MenuButton
                      as={IconButton}
                      icon={campaignModal ? <GrClose /> : <GrPhone />}
                      size={"sm"}
                      p={2}
                    />
                  </Box>
                  <Box>
                    <MenuButton
                      as={IconButton}
                      icon={
                        colorMode === "light" ? (
                          <MdOutlineDarkMode />
                        ) : (
                          <SunIcon />
                        )
                      }
                      onClick={toggleColorMode}
                      size={"sm"}
                      p={2}
                    />{" "}
                  </Box>
                  <Box
                    cursor={"pointer"}
                    onClick={() => {
                      window.location.href = `mailto:${
                        myDetails?.branding?.agency_mail ||
                        "support@insighto.ai"
                      }`;
                    }}
                  >
                    <MenuButton
                      as={IconButton}
                      icon={<MdLiveHelp />}
                      size={"sm"}
                      p={2}
                    />{" "}
                  </Box>
                </>
              ) : null}
              {campaignModal ? (
                <Box
                  border={"1px solid lightgray"}
                  position={"absolute"}
                  top={59}
                  width={350}
                  boxShadow={"md"}
                  p={2}
                  right={20}
                  zIndex={3}
                  bg={bg}
                  borderRadius={"md"}
                >
                  <CallDropDownModal />
                </Box>
              ) : null}
            </Flex>
          </Menu>
        </Flex>

        <Box
          w={"100%"}
          h={"100%"}
          overflowY={"auto"}
          p="4"
          marginLeft={variants?.navigation === "sidebar" ? "0" : "0"}
        >
          {children}
        </Box>
      </Flex>
    </Flex>
  );
};

export default Layout;
